<template>
<div class="chapter">
<div class="inner_page">
<a id="page_15"></a>
<h2 class="ct">WEDNESDAY, AUGUST 10, 1988</h2>
<h2 class="ct1">THE SECOND DAY</h2>
<a id="page_16"></a>
<a id="page_17"></a>
<p class="noindent"><span class="bold"><span class="font1">8:40 A.M.</span></span> Lou
            Bender marched past the President’s secretary without so much as a nod and pushed
            through the door into the Oval Office. Sam Baker swiveled around in his chair to greet
            him.</p>
<p class="indent">“What is it, Lou?” he said.</p>
<p class="indent">Bender slapped a copy of <em class="italic">The New York Times</em> on
            the desk between them.</p>
<p class="indent">“That’s our man,” Bender said.</p>
<p class="indent">President Baker looked down at the banner headline:</p>
<p class="center">COLONEL MARTINEZ ASSASSINATED ON CAPITOL STEPS</p>
<p class="noindent">And beneath that:</p>
<p class="center"><em class="italic">Senator Fallon’s Heroic Address Stuns
                Nation</em></p>
<p class="indentt">There were two photographs, one, the fallen Martinez, and the other,
            Fallon at the podium; his image was nothing less than messianic.</p>
<p class="indent">“Because he’s able?” the President said.</p>
<p class="indent">“Because he’s famous.”</p>
<p class="indent">“But what kind of man is he? What’s he made of?”</p>
<p class="indent">“The same thing all good running mates are made of.
            Ink.”</p>
<p class="indent">The President leaned back in his old desk chair. He had known Lou Bender
            for twenty-nine years. Through six congressional and senatorial campaigns and one long
            run for the White House, Lou Bender had been there, and had been right.</p>
<p class="indent">Now, Bender was a grizzled old politico in a black suit, a starched white
            shirt, and a thin black tie that didn’t reach his belt. He was a short, small man
            with a taut little face, a shock of loose white hair and busy, miniature hands. The
            coming Presidential election, their bid for a second term, was Bender’s last
            hurrah. Win, lose, or draw, it was the last hurrah for both of them. They were behind.
            They knew it. The nominating convention was eight days away.</p>
<a id="page_18"></a>
<p class="indent">“We’ve got a Vice President,” the President finally
            said. “His name’s Dan Eastman. What about him?”</p>
<p class="indent">Bender put his hands in his pockets, looked down at the shine on his
            shoes. “What about him?” he said, as if he didn’t give a damn.</p>
<p class="indent">The President could see that Bender believed Terry Fallon was a gift from
            the gods—a gambit that could clinch a second term. Bender had that look in his
            eyes that a pit bull gets when it locks its jaws and even death can’t break its
            grip. It was a look that President Baker admired, and mistrusted. Because he knew it
            meant shortcut, compromise, expediency.</p>
<p class="indent">Four years before, they had forged a coalition with Dan Eastman, the burly
            governor of Pennsylvania, a trolley car mechanic’s son with hands as big as a
            catcher’s mitt. Eastman was a brawling, two-fisted, sell-and-repent politician, a
            throwback to Tweed and Daley. He was the perfect running mate for Senator Samuel Baker,
            the Virginia planter and white-shoe Wall Street lawyer. Lou Bender had said so. And in
            these matters, Bender was infallible. The election was a Baker-Eastman landslide.</p>
<p class="indent">But that night—November 4, 1984—had been the high watermark
            of their popularity. From that day op, almost without remission, their approval scores
            began to slide. It was like running on a treadmill that moved at gradually increasing
            speed. For a short while, they won as many new constituents as they lost. But, as the
            months rolled by, the lingering problems of the country resisted treatment like a
            stubborn rash. Each day, Sam Baker ran a little faster, a little harder. But the
            treadmill whirred on, accelerating.</p>
<p class="indent">The once-congenial newspapers blinked, then inexorably began to turn their
            faces away. The rhetoric of the television commentators became less conciliatory, more
            strident and judgmental. And the polls<em class="italic">—The New York
                Times/CBS</em> poll, the NBC/Associated Press poll, the <em class="italic">ABC/Washington Post</em> poll, the NOW poll, and the Gay Men’s Caucus
            poll—the all-powerful polls showed Baker-Eastman losing ground as the third year
            of their administration juddered to a close.</p>
<p class="indent">In December of last year, a high-level party delegation had come to the
            Baker ranch in Santa Fe, six awkward men in blue suits and white shirts with the red
            desert dust on their black wing-tip shoes. Old Charlie O’Donnell, the Speaker of
            the House of Representatives, spoke for the group. He ticked off the accomplishments of
            the Baker-Eastman administration. He was <a id="page_19"></a>perhaps too lavish in his
            praise for the success of tax reform, the rejuvenation of the space shuttle program, the
            progress on international-trade and industrial recovery. But in the end, his soliloquy
            came down to one simple question: for the good of the party, would President Baker step
            aside at the nominating convention?</p>
<p class="indent">Sam Baker knew O’Donnell was right. He knew he was in for an uphill
            fight, a fight that he might not be able to win. But he couldn’t see himself
            retired: an old man in a rocking chair, yarning away a string of interminable afternoons
            that unraveled to the grave.</p>
<p class="indent">“I’m sorry,” he had finally said.</p>
<p class="indent">Then O’Donnell turned to Dan Eastman.</p>
<p class="indent">“Drop dead,” Eastman said.</p>
<p class="indent">Now, eight months had passed, the nominating convention was only eight
            days away, and O’Donnell’s prophecy had come true. The party was divided.
            It probably could not deny renomination to an incumbent President. But there was a
            growing sense of indolence and ennui among the regulars. Everyone said so—even
            George Will. “All President Baker needs to be re-elected,” Will wrote in
                <em class="italic">Newsweek</em>, “is 50 million votes and a
            miracle.” In politics there were no miracles, only ploys.</p>
<p class="indent">But he had no appetite for expediency. There was an ugliness about
            expedient politics, like a deformed infant that was undeniably a monstrosity, but
            nevertheless one’s own. It was useless to deny its paternity. But it was
            impossible to embrace it without revulsion.</p>
<p class="indent">“I’ve ordered class one Secret Service protection for
            Fallon,” Bender was saying. “The same as Eastman and you.”</p>
<p class="indent">But Sam Baker stared out the window, lost in his reverie.</p>
<p class="indent">“Mr. President?”</p>
<p class="indent">At last, he looked back at Bender. “I’m sorry,
            Lou.”</p>
<p class="indent">“I said, I’ve ordered class one Secret Service protection
            for Fallon.”</p>
<p class="indent">“Why? He wasn’t the target.”</p>
<p class="indent">“He just made himself a target.” Bender took a cigar out of
            the humidor on the President’s desk. “A lot of your constituents want us
            out of Central America.” Bender bit off the end of the cigar, spit it into the
            wastebasket. “Besides, he’s just become the party’s favorite son.
            Got a light?”</p>
<p class="indent">“No.”</p>
<p class="indent">Bender stopped. He stared at the President. “What’s your
            problem?”</p>
<a id="page_20"></a>
<p class="indent">“Dan Eastman.”</p>
<p class="indent">“No problem.”</p>
<p class="indent">“It stinks, Lou.”</p>
<p class="indent">Bender went to the President’s desk, opened the top right-hand
            drawer and found a pack of matches. It was not the first time they had disagreed.
            “I’ll tell you what …” He wet the end of his cigar with the
            tip of his tongue. “We’ll do it this way. You ask Fallon to give the
            keynote speech at the convention next week. After what’s happened, the delegates
            will hand him the number two slot by acclamation.”</p>
<p class="indent">“What about Eastman?”</p>
<p class="indent">“If the delegates want Fallon, what choice has he got? He’s
            got to step aside.” Bender shrugged and smiled. “Fallon is in, we get our
            second term, and Eastman is out with no fingerprints on the body. Right?”</p>
<p class="indent">“We’ll see.” The President sat down at his desk.
            “Now please excuse me.”</p>
<p class="indent">But Bender didn’t move. “Right?”</p>
<p class="indent">“Lou, I said we’ll see.”</p>
<p class="indent">The President’s intercom sounded. He pressed a button.</p>
<p class="indent">“Yes, Katherine?”</p>
<p class="indent">“It’s Speaker O’Donnell, sir.”</p>
<p class="indent">The President looked at the buttons on his telephone; none was lit.</p>
<p class="indent">“Which line, Katherine?”</p>
<p class="indent">“He’s here in the reception room, sir.”</p>
<p class="indent">The President shut off the intercom. He looked at Bender.
            “O’Donnell? At this hour? What do you think he wants?”</p>
<p class="indent">Bender struck a match. “Vultures like to hit before the body gets
            cold.”</p>
<p class="indent">Now Sam Baker understood what he had to look forward to—a day-long
            parade of pundits and power brokers all peddling the same idea—dump Eastman, grab
            Fallon. He would have to sit and listen to them, hear them out, acknowledge their logic.
            But he alone could make the decision to replace Dan Eastman—if it had to be made.
            And he alone would live with it forever on his conscience.</p>
<p class="indent">Lou Bender lit his cigar, rolling it slowly between his fingers. Then he
            blew a huge puff of acrid smoke into the air.</p>
<p class="indent">“Let’s not be dainty, Mr. President. One martyr is enough
            for this campaign.”</p>
<a id="page_21"></a>
<p class="indentt"><span class="bold"><span class="font1">8:50 A.M.</span></span> For years,
            Sally Crain had worked to build the popularity of elected officials, to give them an
            image, to make them stand for something in the public mind. She had relished success and
            tasted failure. She had seen her ideas realized and dashed.</p>
<p class="indent">But nothing she had experienced even approached the events of the past
            twenty-four hours.</p>
<p class="indent">When the medics hustled Terry down the steps of the Capitol toward the
            waiting ambulance, she clung to the cold steel rails of the stretcher, running
            alongside. All around her, men and women were weeping. An old woman tossed her rosary on
            the stretcher as Terry’s gurney rolled through the street.</p>
<p class="indent">At first, the Secret Service wouldn’t let Sally board the
            ambulance. But she wouldn’t let go of the stretcher, and she saw that they
            didn’t have it in their hearts to deny her.</p>
<p class="indent">As the ambulance wove through the streets of Washington behind the wailing
            sirens of the police escort, .the medics worked like men possessed, cleaning and
            stanching Terry’s wound. They started an I.V. on radio instructions from Walter
            Reed. Sally held Terry’s hand until he lapsed into unconsciousness. When he did,
            one of the medics pressed Sally’s head to his own chest and held her all the way
            to the hospital.</p>
<p class="indent">In the emergency room, six doctors were waiting to rush Terry into the
            O.R. There were fifty aging men from the MacArthur Post Number 101 of the American
            Legion in the blood bank wearing blue caps and campaign ribbons, some of them in
            wheelchairs, all waiting to be typed so that they could give the blood Terry needed,
            bickering with each other over who had arrived first, who had seniority, who might be
            chosen for the honor of being a donor. A monsignor from the Washington archdiocese
            arrived ten minutes later to tell Sally that the Pope would say mass for Terry’s
            recovery at Evensong in Rome. He brought two nuns who went upstairs to the chapel to
            hold a solemn vigil through the night.</p>
<p class="indent">Nothing in Sally’s experience had prepared her for the out <a id="page_22"></a>pouring of love, the willingness to sacrifice, the selfless
            kindness of the people about her. She sat in the small, private waiting room, staring
            out at the traffic passing silently on the streets below. At eleven o’clock, the
            surgeon, an army colonel, came to tell her that Terry was out of the operating room. His
            wound was painful and bloody, but no major organs were damaged. He would need rest. But
            he was safe. Sally went home and changed her clothes. When she came back in the
            afternoon they let her see him.</p>
<p class="indent">An army sergeant and a corporal flanked the door. They checked
            Sally’s likeness on her ID, noted her name on a clipboard. Then she went
            inside.</p>
<p class="indent">The sun cast a dull orange glow through the drawn curtains. The army nurse
            beside the bed rose silently, and Sally took her place. The only sound was the soft,
            repetitive ping of the cardiac monitor. In the massive mechanical bed, Terry seemed so
            small, the sheet lay almost flat. He had been catheterized. His face was pale, almost
            ashen; his face looked damp and cold.</p>
<p class="indent">Sally sat a long moment, staring dully at the bed. Then she stretched her
            hands forward on the top sheet until she felt Terry’s body under the covers. She
            lay her head on her arms and drifted into sleep.</p>
<p class="indent">She did not hear the nurses come and go during the night. She was not
            aware of the doctors who came by on their rounds. All night long she lay, head down,
            arms outstretched like a supplicant, fingers in delicate contact with the warm life
            beating beneath the sheets. She did not hear the noise of the reporters in the corridor
            the next morning. It wasn’t until she felt Terry move under her hands that her
            eyes opened. For a moment, she could not remember where she was. Then she sat up
            abruptly. Terry was looking at her. It was only then that she remembered what had
            happened, where she was, and that it was over.</p>
<p class="indent">She looked toward the muffled sound of reporters’ questions that
            filtered through the door.</p>
<p class="indent">“They woke you,” she said, and started to rise.
            “I’ll have the police move them back into the lobby.”</p>
<p class="indent">He moved his lips as though he wished to speak; they were dry and badly
            cracked. “No. Don’t go … just now.”</p>
<p class="indent">She went to the sink, dampened a tissue, and touched it gently to his
            mouth. He licked the moisture gratefully.</p>
<p class="indent">“Am I … all right?” he asked.</p>
<p class="indent">“Mending.”</p>
<a id="page_23"></a>
<p class="indent">“Is it … serious?”</p>
<p class="indent">“No.” She sat beside him. “You’ll be
            fine.”</p>
<p class="indent">Then a shadow seemed to pass across his face. “How … how
            could this happen?”</p>
<p class="indent">She took his hand in both of hers. “I don’t know. I
            don’t understand it.”</p>
<p class="indent">Then that grinning little boy looked out from inside him. “What are
            the papers calling it? A nick? The proverbial flesh wound?”</p>
<p class="indent">She squeezed his hand, held on as though if he slipped her grasp
            he’d be lost to her forever. “They’re calling you a
            hero.”</p>
<p class="indent">He raised his other hand and cupped the side of her face. “Are
            they?” he said, with a soft, ironic smile.</p>
<p class="indent">And she buried her face in the hollow of his palm and, for the first time
            in a very long time, she began to cry.</p>
<p class="indentt"><span class="bold"><span class="font1">9:05 A.M.</span></span> Just then,
            the President was leaning forward, his elbows on his desk, listening intently to the two
            men seated before him. He was sure that one of them was lying.</p>
<p class="indent">The bald one, the wiry little man in the dark blue suit was Admiral
            William Rausch, director of the CIA. The other, the chubby, cantankerous Irishman in
            the tweed jacket was Henry O’Brien, director of the FBI. There was no love lost
            between them. Lou Bender stood near the windows neither in nor out of the
            conversation.</p>
<p class="indent">“How do you know it was Petersen?” Rausch finally said.</p>
<p class="indent">O’Brien referred to a little spiral notebook. He was a cop, had
            always been a cop, had never stopped being a cop. He was methodical, meticulous,
            persnickety—a compulsive compiler of facts. He could be infuriating.</p>
<p class="indent">“Our agents got a positive ID,” O’Brien said.
            “Two secretaries passed the perpetrator in the north hall near stairway six to
            the roof.”</p>
<p class="indent">“The FBI’s been wrong before,” Rausch said.</p>
<p class="indent">“Come on, Bill. They picked his mug shot.”</p>
<p class="indent">“Together?”</p>
<p class="indent">“Separately. He was CIA for five years,” O’Brien
            said. He flipped his little notebook closed. “He’s your man and
            that’s an end to it.”</p>
<a id="page_24"></a>
<p class="indent">Rausch slouched down in his chair. “He <em class="italic">was</em> ours. Until he went free-lance.”</p>
<p class="indent">“Why?” the President said. “Why did he go
            free-lance?”</p>
<p class="indent">Rausch shrugged. “Drugs. Money. Who the hell knows why these guys
            do what they do?”</p>
<p class="indent">“Conscience?” Bender said behind him.</p>
<p class="indent">Rausch looked back over his shoulder. “In the case of Petersen, you
            needn’t worry about conscience.” He turned and looked at the President.
            “He’s a mindless, flawless, cold-blooded killer.”</p>
<p class="indent">“Working for whom?” the President said.</p>
<p class="indent">Rausch opened his hands.</p>
<p class="indent">“I see. Where is he now?”</p>
<p class="indent">O’Brien said, “We’ll find him.”</p>
<p class="indent">And then, softly, to no one in particular, Bender said, “Do we want
            to find him?”</p>
<p class="indent">It was very quiet in the room for a moment. Then O’Brien blinked
            and looked at Bender as though he wasn’t sure what he had heard.</p>
<p class="indent">“I’m just wondering out loud, Henry,” Bender said.
            “Just wondering what our Latin American allies will think if they find out that
            Martinez was gunned down by a former member of our own CIA.”</p>
<p class="indent">Rausch said casually, “Speaking for the Company, if we never see
            him again, it’ll be one day too soon.”</p>
<p class="indent">O’Brien sat up. “Let me get this straight. An ally of the
            American government was shot dead on the steps of the Capitol. And you’re telling
            me you don’t want to find his killer?”</p>
<p class="indent">Bender’s voice behind him was soft, oily. “No one said we
            didn’t want to find the killer, Henry.”</p>
<p class="indent">O’Brien could smell whitewash, and the odor burned his nostrils.
            “Now, listen to me,” he said. “I’m telling you there has to
            be an investigation by the FBI. Or there is going to be a congressional circus that will
            make the Warren Commission look like a kangaroo court.”</p>
<p class="indent">He glared at Rausch. But the CIA director sat silent, looking straight
            ahead. Bender came up behind O’Brien and put his hand on the back of his
            chair.</p>
<p class="indent">“Of course, there are investigations … and then there are
                <em class="italic">investigations</em> …”</p>
<p class="indent">O’Brien said, “I don’t believe what I’m
            hearing. This was cold-blooded murder!”</p>
<a id="page_25"></a>
<p class="indent">He looked to the President. But now Sam Baker understood. There was
            another dimension to this murder, some terrible secret. It was something Lou Bender
            might know, but the President must not.</p>
<p class="indent">The President rose. “Thank you, gentlemen,” he said. Rausch
            stood. Only O’Brien sat, blinking and bewildered, looking among the faces of the
            three men. The President’s intercom buzzed.</p>
<p class="indent">“Yes, Katherine?”</p>
<p class="indent">“Vice President Eastman is on the phone, sir,” she said.
            “And Mr. Flaherty is here.”</p>
<p class="indent">“All right,” the President said, and pressed the button that
            would put Eastman’s call on the line when he lifted the receiver.</p>
<p class="indent">Bender cleared his throat and the President looked up. Pat Flaherty was
            the White House political pollster. If he had come to the President’s office
            without an appointment, he must have news of enormous importance.</p>
<p class="indent">The President looked again at the blinking light on the phone that
            indicated Eastman’s call. Then he pressed the button for the intercom instead.
            “Katherine, send Flaherty in.”</p>
<p class="indent">Almost in that very instant the door opened and Flaherty burst in waving a
            computer printout. “A 91 awareness and an 88 Q! This guy Fallon is bigger
            than Cosby! There’s no doubt about it, Mr. President. He’s the guy
            you can win with!”</p>
<p class="indent">The President stared at Bender. Bender put his hands in his pockets,
            looked down at the shine on his shoes.</p>
<p class="indent">The President pressed the button on his intercom.
            “Katherine—” Then he stopped. He was about to take a
            step—and it was an irrevocable step, one that he could never retrace.
            “Katherine, tell the Vice President I’ll call him back.”</p>
<p class="indent">O’Brien got to his feet. He glared at Bender. Then at Rausch.
            Without saying a word, he shoved Flaherty aside and pushed out through the door.</p>
<p class="indentt"><span class="bold"><span class="font1">10:05 A.M.</span></span>
            “Fuck you!” Joe Mancuso shouted. He shoved so hard that Dave Ross
            bounced off the glass wall at the rear of the court and had to charge back to hit the
            ball on the carom. It was more like hand-to-hand combat than handball.</p>
<p class="indent">“Cocksucker!” Mancuso roared, as Ross’s lob
            arced back over his head. He turned to run it down, smacked into Ross again, shoved the
            younger man aside. “You’re blockin’!”</p>
<a id="page_26"></a>
<p class="indent">“Your ass!”</p>
<p class="indent">Mancuso barely caught up with the ball, slapped it backhand off the
            sidewall toward the front. He pushed off the rear wall and doggedly headed back the
            other way.</p>
<p class="indent">“I’ll kill you,” he panted, as he went by Ross.</p>
<p class="indent">“Try it!” Ross squared in position in the forecourt
            as Mancuso’s weak return bounced at his feet. He cut a delicate little drop shot
            into the right corner.</p>
<p class="indent">Mancuso smacked into him, shoulders down. “Move
            it!”</p>
<p class="indent">Ross almost lost his balance, barely recovered to chase Mancuso’s
            save into the far left corner. Now he had Mancuso trapped in the forecourt. Ross hit a
            savage cross-court return.</p>
<p class="indent">But the older man took it on the volley and slapped it down the right-hand
            wall. Ross leaped for it.</p>
<p class="indent">Mancuso stuck his leg out. Ross went flying on his face, skidding in his
            own sweat across the shiny maple floor. The ball bounced past his outstretched hand,
            died in the far corner.</p>
<p class="indent">Ross rolled over, angry fists clenched. But when he looked up, Mancuso was
            laughing.</p>
<p class="indent">“You rotten old crook,” Ross gasped, breathless.</p>
<p class="indent">“You’re bitchin’. But you’re buying.”
            Mancuso gave him a hand up.</p>
<p class="indent">Ross laughed, too. In two years, handball was the one thing they had found
            in common. In fact, Ross was no handball player—he was a squash player who
            learned the game at Yale, perfected it at Georgetown Law School. One day in the gym in
            the basement of the Hoover Building, he had run into Mancuso in the lockers, changing
            into shorts.</p>
<p class="indent">“You play squash?” Ross had said.</p>
<p class="indent">“Handball.”</p>
<p class="indent">“Try squash?” Ross held up the light, elegant racquet.</p>
<p class="indent">“That’s for pussies.” Mancuso threw him a dirty old
            pair of handball gloves.</p>
<p class="indent">More out of cussedness than curiosity, Ross had learned the game. These
            days they were well matched: the dark, muscular kid who looked like he was still in prep
            school, but hit sixty miles an hour off either hand, and the aging, stubborn bull who
            chased down every shot, who always seemed about to drop but never did.</p>
<p class="indent">Ross knew what he was getting into when the Bureau handed him Mancuso as
            his partner. Mancuso was a lifer, a thirty-year man, a misanthropic, saturnine old dick
            who had, nothing to <a id="page_27"></a>show for his career with the FBI: no family no
            friends, no stripes. He was still only a grunt agent when all his contemporaries were
            either special-agents-in-charge or memories. He was a mean, silent hulk of a man. And as
            his time drew on toward retirement, he had become even more private and withdrawn. Ross
            appealed. He even volunteered for immigration enforcement. No soap. He was
            Mancuso’s, Mancuso was his—until death or retirement them did part.</p>
<p class="indent">Ross picked up his blue Ralph Lauren gym bag, and threw Mancuso’s
            towel in his face.</p>
<p class="indent">“One round, then I’m back on duty.”</p>
<p class="indent">But something outside the court caught Mancuso’s eye.
            “Chickie. The bulls.”</p>
<p class="indent">In the hallway beyond the rear glass wall, Supervisory Special Agent
            Barney Scott stood in his double-breasted brown pinstripe, hands in his pockets,
            glaring.</p>
<p class="indent">Mancuso and Ross came out.</p>
<p class="indent">“Hiya, Chief,” Ross said, and wiped at the sweat pouring off
            his neck.</p>
<p class="indent">“Your shift don’t break till noon, Ross.”</p>
<p class="indent">“He took an early lunch,” Mancuso said.</p>
<p class="indent">Scott sneered. “You been out to lunch since ’79, Joe. Why
            don’t you take your pension and give the Bureau a break?”</p>
<p class="indent">“I got three months till fifty-five-and-out, Scotty. Then
            I’m history. And in the meanwhile, fuck you.”</p>
<p class="indent">He started to walk away. Scott poked his index finger in Mancuso’s
            shoulder to stop him.</p>
<p class="indent">“I’d love to bust your pension for
            insubordination.”</p>
<p class="indent">The two men stared at each other. They had thirty years of grit between
            them, and it rubbed hard.</p>
<p class="indent">“I didn’t hear anything,” Ross said.</p>
<p class="indent">Scott turned on him. “You watch your step, Ross. You got a long way
            to go before you cash in. And until then, your ass is mine.”</p>
<p class="indent">“Eh, fongool!” Mancuso said, and gave Scott the
            Italian salute and laughed. “Come on,” he said to Ross, and the two
            started down the corridor toward the lockers.</p>
<p class="indent">“You can skip the shower,” Scott called after them.
            “Man on the sixth floor wants to see you two.”</p>
<p class="indent">Mancuso snorted. “Sure, he does. And he’s gonna send us on
            vacation to Acapulco.” He elbowed Ross, who elbowed back, and they both laughed
            out loud.</p>
<a id="page_28"></a>
<p class="indent">“It’s about the Martinez assassination,” Scott
            said.</p>
<p class="indent">That stopped them, dead.</p>
<p class="indent">They looked back.</p>
<p class="indent">“Up yours, guinea,” Scott said. And he shot them the Italian
            salute.</p>
<p class="indentt"><span class="bold"><span class="font1">10:10 A.M.</span></span>
            “You two look like a couple of clowns,” Henry O’Brien said. Ross
            with his blue gym bag, Mancuso with his towel, stood sweating and feeling ridiculous in
            the middle of the long, oak-paneled office of the director of the FBI. A small
            gray-haired man sat in the far corner.</p>
<p class="indent">“Mancuso, I’m assigning you as agent-in-charge of the
            Martinez investigation. Ross will be your backup,” O’Brien said.</p>
<p class="indent">There was a long silence. Mancuso shuffled his feet. “Yeah,”
            he said. “Well, I’m out of here in three months, Boss.” He called
            O’Brien “boss” to keep from slipping and calling him
            “Blinky,” the nickname the guys had hung on O’Brien when he joined
            the Bureau in 1957.</p>
<p class="indent">“I understand that,” O’Brien said. “When you
            move on, we’ll assign another senior agent if the case is still open.”</p>
<p class="indent">That made Mancuso raise his head. “If?”</p>
<p class="indent">But O’Brien ignored him. “You are to keep the facts of this
            case and particularly the name of the assailant strictly confidential
            for—” he wet his lips “—for reasons of national
            security.”</p>
<p class="indent">Mancuso thumbed back over his shoulder. “Then how do
            we—”</p>
<p class="indent">“Just do your best,” O’Brien said.
            “That’s all.”</p>
<p class="indent">Mancuso and Ross stood, silent.</p>
<p class="indent">“I said, that’s all.”</p>
<p class="indent">“Yes, sir.” They went out and shut the door behind them.</p>
<p class="indentt">Ross could barely contain his excitement as he followed Mancuso into the
            hall. When they were alone, he caught his arm.</p>
<p class="indent">“Jesus! The Martinez gig.”</p>
<p class="indent">“It’s a setup,” Mancuso said.</p>
<p class="indent">“Huh?”</p>
<p class="indent">Mancuso waved him silent, walked on.</p>
<a id="page_29"></a>
<p class="indentt"><span class="bold"><span class="font1">10:10 A.M.</span></span> Plump,
            eager Christopher Van Allen backed into Terry’s hospital room. When he turned
            around, Sally saw that his arms were full of newspapers.</p>
<p class="indent">She had borrowed a yellow pad from a supervisor to log the telegrams and
            flowers and fruit baskets that had begun to arrive before nine o’clock. An hour
            later, the room was awash in roses, chrysanthemums, pineapples, and Godiva chocolates.
            Terry was sitting up, sipping orange juice through a straw, still shaky but gathering
            strength.</p>
<p class="indent">Chris was elated. “Three—count ’em—three
            network special reports. Every newspaper.” He tossed them on the foot of the bed.
            “New York. Chicago. L.A. Detroit. Did I tell you Barbara Walters called for an
            interview?” He spilled the whole pile of papers at Terry’s feet. Then he
            grabbed the handkerchief from his breast pocket and wiped his pudgy, grinning face.
            “Jesus, Terry, you’re a household word!”</p>
<p class="indent">Exhausted, Sally picked up the <em class="italic">Detroit Free
                Press</em>, absently scanned the headline and photographs of Terry and Martinez.
            Terry stared blankly into the distance.</p>
<p class="indent">Chris looked as if he would burst. “Jesus, can’t you even
            smile?”</p>
<p class="indent">Terry said, “And just forget Octavio Martinez lived and
            died?”</p>
<p class="indent">Chris stood where he was, deflated, ashamed.</p>
<p class="indent">The phone rang.</p>
<p class="indent">Sally answered it. “Yes?” Then her face went slack. She
            covered the mouthpiece. “It’s the President.” She handed the phone
            to Terry and stood up, away from the bed.</p>
<p class="indent">Terry cleared his throat. Then he put his ear to the phone.</p>
<p class="indent">“Yes, Mr. President?” He paused and listened. “A lot
            better now, thanks. Yes. Yes, sir. As soon as I’m able.”</p>
<p class="indent">He handed the phone to Sally and eased back into his pillow, staring at
            the ceiling. Sally and Chris stood in silence.</p>
<p class="indent">But when he could hold his peace no more; Chris whined, “Aw, Terry,
            tell us.”</p>
<p class="indent">Terry did not look at them. His voice was mechanical. <a id="page_30"></a>“He says he must speak to me as soon as I’m up and
            around.”</p>
<p class="indent">Chris kept a straight face as long as he could. Then he clapped his hands
            once, hard. “Fuckin’-ay!” he shouted, and he didn’t
            care who heard him.</p>
<p class="indentt"><span class="bold"><span class="font1">11:55 A.M.</span></span> Doctor
            Paul Summers wore an impeccable white lab coat and thick, round, rimless glasses. He
            looked like a zoology professor Ross had studied with at Yale. Ross always felt like he
            was back at school when he sat in the operating theater of the FBI forensics lab. Now,
            he sat taking notes while Joe Mancuso sat beside him, his feet on the chair in front of
            him, absently picking his ear.</p>
<p class="indent">“In all respects, a very elegant shoot,” Doctor Summers
            said.</p>
<p class="indent">“How so?” Mancuso said.</p>
<p class="indent">Summers held up a photomicrograph of a shell casing. He used his pencil as
            a pointer. “From the markings on the casings, we know that the rifle was a
            Heckler &amp; Koch HK-91. These horizontal striations—”</p>
<p class="indent">“Yeah, sure,” Mancuso said. “What kind of gun is
            that?”</p>
<p class="indent">Summers stopped, looked over the top of his glasses at Mancuso. Then he
            quietly put the photoprint down and picked up the rifle from the table before him. He
            pulled the bolt to; it rang with a sharp metallic clang.</p>
<p class="indent">“Automatic,” he said.
            “Five-shot standard or twenty-round box clip. Fires ten rounds a
            second.”</p>
<p class="indent">“Whose issue?”</p>
<p class="indent">“Nobody. It’s for specialists.”</p>
<p class="indent">“Yeah?”</p>
<p class="indent">“NATO snipers.”</p>
<p class="indent">Ross looked up from his notes.</p>
<p class="indent">Summers put the rifle down and picked up another photoprint, this one a
            bullet. “Fires a <em class="italic">7.62</em> high-velocity slug. An
            experienced shooter can hold down the trigger and still keep the whole burst in the
            black.”</p>
<p class="indent">“What kind of slug?” Mancuso said.</p>
<p class="indent">“Name it. Soft-point, hollow, flat-nose, Teflon, full-steel jacket.
            It depends on how your target is protected—and how hard you want him to
            die.”</p>
<a id="page_31"></a>
<p class="indent">“How hard did Martinez die?” Ross said.</p>
<p class="indent">“A near miss on the first one was enough to do the job. The rest of
            the clip was—” he shrugged “—extreme prejudice.”
            Summers folded down the picture of the bullet. Behind it was a photo of another bullet,
            one that had struck its mark. The point was mushroomed and deformed, the metal
            flattened, spread wide, a dozen razor-sharp edges gleaming.</p>
<p class="indent">“This load is Tauride. It’s manufactured by Arms Ariadne in
            Deauville. It mushrooms to four diameters on impact. Cuts a tiny entry wound, then rips
            the guts to shreds. If it hits bone, it fragments. So does the bone. Fallon
            doesn’t know how lucky he is.” Summers put the picture down.
            “Here’s the brass.” He tossed a plastic evidence bag to Ross.
            “SID found those on the roof of the Russell Building.”</p>
<p class="indent">Ross held the plastic bag up to the light. The empty cartridges jangled.
            He opened the Ziploc and spilled them into his palm. They were light as air to be so
            deadly. They were also heavily scratched.</p>
<p class="indent">“These been used before?”</p>
<p class="indent">“Pro hitters load their own. All the casings are
            reloads.”</p>
<p class="indent">Six of the cartridges were identical brass. The seventh was black.</p>
<p class="indent">“These don’t match,” Ross said.</p>
<p class="indent">“Same caliber, mixed brass,” Summers said. “You see
            that a lot with home loads.”</p>
<p class="indent">“What else, what else?” Mancuso said, impatient.</p>
<p class="indent">Summers picked up his clipboard, sat down on the edge of the table, and
            began to thumb through it. “I performed an autopsy on Martinez. Want to hear
            about it?”</p>
<p class="indent">“Fuck that,” Mancuso said. “Guy shot him, he
            died.”</p>
<p class="indent">“He was going to die anyhow.”</p>
<p class="indent">“How do you mean?” Ross said.</p>
<p class="indent">“Colonel Martinez had AIDS.”</p>
<p class="indent">Ross stopped writing.</p>
<p class="indent">Beside him, Mancuso said, “So he was a fruit. Lots of spies are
            fruits.”</p>
<p class="indent">Summers shook his head, sighed. He turned to another page. “The man
            was married. He had three … no, four children.”</p>
<p class="indent">“So, he was acey-deecy.”</p>
<p class="indent">“He was a devout Catholic. A daily communicant.” Mancuso got
            up from his chair. “Listen, Doc. Lots of old altar boys play hide-the-weenie
            where they shouldn’t.”</p>
<a id="page_32"></a>
<p class="indent">Summers put his clipboard down on the table. “You know, Mancuso,
            you’re a real scumbag.”</p>
<p class="indent">Mancuso shrugged, straightening his tie.</p>
<p class="indent">“What are you getting at, Doc?” Ross said.</p>
<p class="indent">“Two days ago, this colonel goes to Walter Reed for a physical.
            They did the whole workup: G.I. series, heart, blood, everything. Yesterday, some
            shooter blows him to kingdom come.”</p>
<p class="indent">“So?”</p>
<p class="indent">Summers took off his glasses. “On Monday, the results show he
            wasn’t AIDS-positive. Tuesday he was. There’s only one
            explanation.”</p>
<p class="indent">“Yeah?”</p>
<p class="indent">“Somebody at Walter Reed juiced him with infected
            blood.”</p>
<p class="indent">There was a long silence.</p>
<p class="indent">“Cute,” Mancuso said.</p>
<p class="indentt"><span class="bold"><span class="font1">12:10 P.M.</span></span> Terry was
            feeling better; his hands had stopped shaking and his vision had cleared. He was sitting
            up in bed, reading glasses down on the end of his nose, a pile of telegrams in his lap.
            Sally sat beside him, her yellow pad resting on the edge of the bed. She was struggling
            to read her own shorthand, but she was fading.</p>
<p class="indent">“I’m sorry,” she said. “That senator …
            was it Fulton or Fulham?”</p>
<p class="indent">Terry took off his glasses.</p>
<p class="indent">“You’re tired,” he said, gently.</p>
<p class="indent">There had been a flood of calls that morning—until she asked the
            switchboard to take messages. There had been an endless stream of nurses carrying
            baskets of flowers, chocolate, and fruit—until she pleaded with the supervisor to
            deliver the cards but distribute the gifts to other patients. And Chris Van Allen kept
            rushing in and out with telegrams from senators, from foreign heads of government, from
            governors, constituents, and friends—until Sally’s head began to swim.</p>
<p class="indent">“I’m not tired,” she said. “Not
            really.”</p>
<p class="indent">Terry smiled and laid his hand on hers, made her put her pencil down. He
            grinned. “How’d you like to slip out and get us a pair of ice cream
            sundaes?”</p>
<a id="page_33"></a>
<p class="indent">She smiled, too. “I would. But they’ve got guards on the
            door.”</p>
<p class="indent">Terry lay back. “Know what I want more than anything in the
            world?”</p>
<p class="indent">“What?”</p>
<p class="indent">He looked at her. There was such caring in her eyes, such tenderness, that
            he knew she would give him anything he asked for, if only it were hers to give.</p>
<p class="indent">He scratched his chin. “A shave.”</p>
<p class="indent">She smiled and ran her fingertips down the stubble on his cheek.
            “You look just right.” They jumped apart at the sound of the door.</p>
<p class="indent">“Jesus Christ,” Chris Van Allen said, and his eyes were
            bulging. “Speaker O’Donnell is coming up the hall!”</p>
<p class="indent">He swung the door wide open and Speaker Charlie O’Donnell rolled
            in. He was a huge, grayed, lofty man, big everywhere—big smile, big feet, big
            jowly face, but little steely gray eyes.</p>
<p class="indent">“Terry, Terry, my boy, how are you?”</p>
<p class="indent">“I’m getting along, sir,” Terry said. “Forgive
            me not getting up. Sally, give the Speaker a chair.” He tried to push himself
            higher against his pillow, but the effort drove the I.V. needle deeper into his arm and
            he winced.</p>
<p class="indent">“Are you in pain?”</p>
<p class="indent">“No, no,” Terry said, waving it away. “They’ve
            got me so full of needles and tubes I can’t scratch without something tearing
            loose.”</p>
<p class="indent">Sally turned her chair for O’Donnell. “Thank you,
            dear.” He plumped himself down. “Terrible tragedy. Just terrible.”
            Then, abruptly, he said, “Could we speak privately?”</p>
<p class="indent">His tone was startling, preemptive.</p>
<p class="indent">“Sally?” Terry said.</p>
<p class="indent">“Of course.” She went out the door.</p>
<p class="indent">Chris Van Allen was Waiting in the hallway.</p>
<p class="indent">“Jeeze,” he said. “O’Donnell himself.”
            Then he looked at Sally. “You’re whipped. Come on, I’ll get you a
            coffee.” He took her arm.</p>
<p class="indent">There were two things in Washington that Chris Van Allen loved being near:
            politics and Sally Crain. On the day of his graduation from Dartmouth, he had taken the
            train to New York, changed for the Metroliner, and reported for work on the staff of
            Caleb Weatherby, senior senator from Texas.</p>
<p class="indent">Weatherby was glad to have Chris Van Allen on his staff. <a id="page_34"></a>Hiring Chris cemented a relationship with Van Allen, Bums and Company, the
            investment bankers at 30 Wall Street. In fact, Weatherby told his friends that he
            “wouldn’t touch the little pansy if it wasn’t the only way to float
            $160 million.” Most of Weatherby’s office staff felt the same way.
            They were first-generation Texas money who wore Gucci cowboy boots to prove
            they’d made it. Chris was a genuine Eastern aristocrat with the right name, right
            family, right connections, and the wrong sexual preference. About the only person in the
            office who took him seriously was Sally Crain.</p>
<p class="indent">Sally understood that Chris Van Allen gave Weatherby’s office
            entree to society—and society was where it had been at under Reagan. Chris was
            old money, and his family had laid a lot of pipe down the generations. Their genealogy
            and their tentacles reached into the social and political Olympia of the cities of the
            East, the Old South, Grosse Pointe, Shaker Heights, all the way west to San Marino and
            Bel Air. A lot of people who wouldn’t return Bunker Hunt’s calls had to
            pick up the phone for a Van Allen. It was a calling card that Caleb Weatherby
            needed—anyone needed—if he really wanted to be Vice President.</p>
<p class="indent">They spent a lot of time together, Chris and Sally. She knew about him and
            he knew she knew and it was fine. Many a night they ordered-in Chinese, sat in front of
            the fireplace in her Georgetown apartment, drinking Beaujolais and spinning dreams.
            There was a deep-running kindness in Sally, and Chris felt closer to her than he had
            ever felt to any woman, closer than he ever dared hope he could. But the house of cards
            came crashing down when Caleb Weatherby was indicted.</p>
<p class="indent">Weatherby was an oil speculator who was worth $40 million—but he never got the dirt out from under his fingernails. When a phony wildcatter
            offered him $150,000 cash against shares, he tried to push the EPA to loosen oil
            leases in plot WT11915. Weatherby was on camera when he agreed to the scheme and again
            when he took the briefcase full of cash. A moment later, the wildcatter and his partner
            revealed themselves as FBI agents. A moment after that, Weatherby was in handcuffs, and
            his career was buried in plot WT11915.</p>
<p class="indent">A year later, a picture of Weatherby flashing the “V for
            victory” sign appeared on page fourteen of <em class="italic">The New York
                Times</em>, with a caption that read: “Former Senator Caleb Weatherby
            entering the federal minimum security facility at Lewisburg to begin serving a
            seven-year sentence for bribery and collusion.” <a id="page_35"></a>By then,
            Texas Governor Wendell Taylor had already appointed Terry Fallon to assume
            Weatherby’s unfinished term.</p>
<p class="indent">Fallon blew through Weatherby’s office like a whirlwind. Nepotism
            and ward-heeling came to a grinding halt. The first month, eleven of twenty-three
            staffers were pink-slipped. Some were replaced by seasoned professionals, others by
            longer hours and hard work. The good people rose to it, and Chris Van Allen was one of
            those.</p>
<p class="indent">Terry Fallon didn’t seem to care that Chris was gay. If anything,
            he took a kind of fatherly interest in the young man, and made him his political liaison
            with the party functionaries. That gave Chris entree to the gut politics of Washington.
            It also opened a new world of sexual opportunity and Chris made the most of that. A lot
            of what he learned, he learned from pillow talk. And the tidbits and secrets he gathered
            made the Fallon office one of the most tuned-in on the Hill.</p>
<p class="indent">The only disappointment that Chris had to face was sharing his friend
            Sally with the senator. Both Sally and Terry came from Houston and had made a nodding
            acquaintance somewhere up the trail. They began to spend a lot of time together,
            working, talking, planning. Fallon’s wife was in an institution for the
            emotionally disturbed in Cleveland. Sally was an ideal surrogate at dinner parties and
            galas—articulate, attractive, widely recognized and respected around town through
            her years as a reporter on the <em class="italic">Post</em> and as press secretary
            to the Weatherby office. There was little idle gossip; it was said that once a month
            Fallon went to Cleveland to visit his deranged wife. If anything, social Washington
            wanted Fallon to divorce his wife and make Sally the next Mrs. Fallon. But they knew he
            wouldn’t. He wasn’t that kind of a man.</p>
<p class="indent">Chris didn’t feel that way at first. He was worried about Sally.
            Terry Fallon was smooth, seamless. Sally was a hardworking career girl with little time
            for herself. If someone as charismatic as Terry took an interest in her, it was sure to
            turn her head. But Terry kept a respectful distance. And the more Chris watched them
            together, the more he realized that Sally could be a friend to both. That was good.
            While that arrangement lasted, Chris would do everything he could to further
            Terry’s career. But if he ever thought Terry was taking Sally away from him
            … If he ever thought that, he might become jealous. And if he did, there was no
            telling what Chris Van Allen might do.</p>
<p class="indent">Now, he steered Sally into the chow line of the hospital <a id="page_36"></a>cafeteria. She rested her hands on her tray and her shoulders sagged with
            exhaustion.</p>
<p class="indent">“You’re dead tired,” he said.</p>
<p class="indent">“I’m okay.”</p>
<p class="indent">“Check into the Mayflower and take, a nap.”</p>
<p class="indent">She yawned and put the back of her wrist to her mouth. “When this
            settles down.”</p>
<p class="indent">Chris drew two cups of black coffee from the urn. “Sally, this
            won’t settle down for five more years.”</p>
<p class="indent">“You think he’ll get it?”</p>
<p class="indent">“Could be.” Chris put the cups on the tray, gave the cashier
            a dollar, led the way toward an empty table. They sat. Sally held her coffee mug with
            both hands, staring down at it as though she hadn’t the strength to lift it.</p>
<p class="indent">“The President’s in trouble in the cities,” Chris
            said. “He’s got a record on welfare that’s criminal. The media
            think he’s a doddering old fart. And they may be right. Terry’s young.
            He’s a veteran. He’s GQ. Women and nonwhites think he’s Rambo in
            pinstripes. As far as Baker is concerned, Terry was born to run.”</p>
<p class="indent">Sally put her elbow on the Formica tabletop, resting her chin in her palm.
            She listened patiently, but her eyelids fluttered with exhaustion.</p>
<p class="indent">“All of which means we’re on our way to four amazing
            years.” Chris stopped and looked at her. “For Pete’s sake, Sally.
            I’m telling you Terry is going to be Vice President, and you’re falling
            asleep!”</p>
<p class="indentt"><span class="bold"><span class="font1">12:20 P.M.</span></span> In a
            calculated, oblique, but leading way, Speaker Charlie O’Donnell had just finished
            saying the same thing.</p>
<p class="indent">“That’s the lay of it, Terry,” he said.
            “That’s what the party leadership is thinking. The President has reached
            no decision. But the party needs to know if you’d accept.”</p>
<p class="indent">Terry eased down, into his pillow. “What do you think,
            Charlie?”</p>
<p class="indent">“I believe a man who is called by his country must serve his
            country. But not if he knows his life is in danger.”</p>
<p class="indent">“You think it’s that bad?”</p>
<a id="page_37"></a>
<p class="indent">The old man put his hands together. “All of us, everyone in public
            life is a target. But you’ve already had one close call. No one would blame you
            if you didn’t want to go on.”</p>
<p class="indent">Terry knew that he was under observation. Finally, he said, “I have
            to follow my conscience, Charlie. Tell the leadership I’ll think on
            it.”</p>
<p class="indent">O’Donnell’s eyes shone with admiration. “God bless
            you, son,” he said, and rose heavily from his chair. “Terry, one more
            thing.” He leaned over the bed. “We need to know … is there
            anything, any background we should talk about? Anything that might come out?”</p>
<p class="indent">Terry stared gravely. “Well,” he said, “you know I
            never miss <em class="italic">Donahue</em>.”</p>
<p class="indent">The old main laughed and Terry laughed with him. Then, his tone
            changed.</p>
<p class="indent">“Harriet,” Terry said. “You know about my
            wife.”</p>
<p class="indent">“Yes, poor soul, we do,” O’Donnell said.
            “Terry, you know we’ll be checking. Is there nothing more?”</p>
<p class="indent">“Absolutely nothing more.”</p>
<p class="indent">O’Donnell stuck out his hand. Terry looked at it. Then he turned
            slightly in the bed and clasped it in his own. It was as though a momentous decision had
            been reached.</p>
<p class="indent">O’Donnell shook Terry’s hand once firmly, then began to let
            go. But Terry held him fast.</p>
<p class="indent">“What about Vice President Eastman?”</p>
<p class="indent">“Yes,” O’Donnell said. “Well.” He
            nodded to himself. “Dan Eastman has served his party for fifteen years. If he has
            to, he’ll serve his party now by stepping aside.”</p>
<p class="indent">Terry gripped the old man’s hand. “But how will he feel? How
            will he take it?” The concern in his face was genuine.</p>
<p class="indent">“Not well,” O’Donnell said.</p>
<p class="indentt"><span class="bold"><span class="font1">2:40 P.M.</span></span> Dan
            Eastman knew something was up—and he had no intention of taking it well. It had
            been five hours since he had called the President. His call had still not been returned.
            He stood, leaning his fists on his desk while Ted Wyckoff, his political analyst, led
            him through the long sheets of computer runs.</p>
<p class="indent">“The good news is your scores haven’t budged.”
            Wyckoff <a id="page_38"></a>pointed to the numbers as he ticked them off. “Most
            people know Dan Eastman is Vice President of the United States.” He ran his
            pencil down a row of numbers to the next boldface entry.</p>
<p class="indent">“And most people rate you good-to-excellent. Here’s the
            problem.”</p>
<p class="indent">Wyckoff turned to the next page and the numbers jumped up and hit Dan
            Eastman in the face.</p>
<p class="indent">“A Baker-Eastman ticket, forty-seven percent. Loser,” Wyckoff said.
            “A Baker-Fallon ticket, fifty-three percent. Winner.”</p>
<p class="indent">“I can read,” Eastman said darkly. He studied the sheet a
            moment longer. “Goddamit!” With an angry sweep of his arm, he
            cleared the desk. Then he dropped into his chair. Wyckoff bent to retrieve the documents
            scattered across the floor.</p>
<p class="indent">Eastman swiveled his chair and looked up at the official photograph of
            President Baker on his wall. He liked Baker, but he didn’t trust him. He
            didn’t trust him because he was a rich man’s son, a Virginia gentleman, a
            Harvard graduate, a Wall Street lawyer, and a Unitarian besides. Sam Baker was
            everything that Dan Eastman had grown up envying and despising. Their political
            coalition had always been an uneasy one. Less than a year after they were elected, they
            tangled.</p>
<p class="indent">By then, Dan Eastman had become one of Washington’s outspoken
            independents. He called former President Carter “a clown” and told Henry
            Kissinger to his face that he “single-handedly lost the war in Vietnam.”
            When interest rates had gone up, he gave an interview to the <em class="italic">Washington Post</em> in which he said “the Federal Reserve is pimping for
            the big banks, and the American home buyer is taking the fall.”</p>
<p class="indent">For a while it seemed that President Baker’s phone was ringing off
            the hook with complaints about Eastman. Complaints from politicians, from congressional
            leaders, cabinet members, from the Pentagon, and the social doyens. Sam Baker finally
            took Eastman over the coals.</p>
<p class="indent">“You’re embarrassing us,” Baker said.</p>
<p class="indent">“I call them as I see them.”</p>
<p class="indent">“You’re costing us support on the Hill. If enough petty men
            turn against us, we won’t be able to move the legislation the country
            needs.”</p>
<p class="indent">“I don’t like fakers,” Eastman said. “I
            don’t like rip-offs. I don’t like liars.”</p>
<p class="indent">“There are white chips and blue chips,” Baker reasoned.
            “Let them have the white chips.”</p>
<a id="page_39"></a>
<p class="indent">“No, Sam. You let them have the white chips. I know the difference
            between right and wrong.”</p>
<p class="indent">Sam Baker stared at him a long moment. “I wish I believed it was
            that simple.”</p>
<p class="indent">“You used to,” Eastman said.</p>
<p class="indent">Now Dan Eastman saw that fate had handed President Baker a trump
            card—Terry Fallon. And he was sure that the ruthless men around the President
            would force Baker to play it.</p>
<p class="indent">Ted Wyckoff had gathered the fallen computer papers, set them on
            Eastman’s desk. “You think the President would replace you on the
            ticket?” he said.</p>
<p class="indent">Eastman swiveled around in his chair. “He sent O’Donnell to
            see Fallon. What do you think they talked about? The weather?”</p>
<p class="indent">Eastman got up and paced to the far end of the room in angry strides.
            “We’ve got to break Fallon,” he said. “I want Niles working
            on his voting record. Tell Davis to cross-check issues that—”</p>
<p class="indent">“Forget it,” Wyckoff said.</p>
<p class="indent">Eastman looked up.</p>
<p class="indent">“There’s no time. The convention starts in a week. He
            can’t be taken on his voting record.”</p>
<p class="indent">“What are you talking about?”</p>
<p class="indent">“You’re not competing with the man,” Wyckoff said. He
            put his hand on the stack of computer printouts. “It’s the
            polls.”</p>
<p class="indent">“But you said Baker and I can’t win.”</p>
<p class="indent">“You can’t.”</p>
<p class="indent">They stood a moment like that, staring at each other.</p>
<p class="indent">Then Wyckoff said quietly, “You just have to prove that Baker and
            Fallon can’t win either.”</p>
<p class="indent">“And how do I do that, smartass?”</p>
<p class="indent">“We get something on him. Something dirty. Something we can slip to
            the papers. It’s his fucking record, not his voting record that we have to go
            after.”</p>
<p class="indent">Eastman went around the desk, stood so close to Wyckoff they were almost
            touching. Then he stuck a finger in the smaller man’s face, and his voice was a
            hoarse whisper. “Listen to me, you little bastard. We’re not playing their
            dirty, shit-ass games.”</p>
<p class="indent">Wyckoff smiled. “No, sir,” he said.</p>
<a id="page_40"></a>
<p class="indentt"><span class="bold"><span class="font1">6:30 P.M.</span></span> The shadow
            of the Lincoln Memorial lengthened in the early summer evening, crept across and down
            the steps toward the Reflecting Pool. Mancuso walked along the edge of the still water.
            He was an aging gumshoe with spots on his tie, sagging polyester socks, and a cheap
            brown suit from Sears. His face was leathery and wrinkled, and he needed a shave. Beside
            him, Ross looked like the tweedy young lawyer that he was.</p>
<p class="indent">“Well, what do you think?” Ross finally said, as if he
            couldn’t contain himself any longer.</p>
<p class="indent">“I think it sucks.”</p>
<p class="indent">But Ross was elated. “Man, what an assignment. Somebody doses the
            guy with AIDS. Then Petersen shoots him. One victim, two murders. That’s got to
            be a first.”</p>
<p class="indent">“Yeah,” Mancuso said. “And the big boys are
            into it.”</p>
<p class="indent">“Huh?”</p>
<p class="indent">“That guy in O’Brien’s office. Bender. He’s
            from the White House. This is a command performance, kiddo.”</p>
<p class="indent">“Well, I’m ready,” Ross said and rubbed his hands
            together. “Which way do we go?”</p>
<p class="indent">Mancuso walked to the edge of the water and looked at his own reflection.
            “Maybe both. Maybe neither.”</p>
<p class="indent">Ross did a take. “What do you mean, neither?”</p>
<p class="indent">“Clerical work. Go through the motions. Don’t make waves.
            That’s all they want.”</p>
<p class="indent">Ross couldn’t believe his ears. “Come on, Joe …”</p>
<p class="indent">“A lame duck and a green kid on a hit like this? Use your head. If
            they wanted it busted, they’d assign a whole division.”</p>
<p class="indent">“I don’t care. I want to try to break it.”</p>
<p class="indent">“Sure you do. Sure you do.” Mancuso turned the corner of the
            pool, began to walk the perimeter east. “The trouble is, there’s two
            horror shows out there. And I got a bad feeling that one of them knows we’re
            coming.”</p>
<p class="indent">He looked eastward the length of the Reflecting Pool. The Washington
            Monument stood glowing gold against the sky in the failing summer light. As long as he
            had been in Washington, as long as he had walked the Mall when he needed time to think,
            that image had stirred Joe Mancuso’s heart. This evening was no exception.</p>
<a id="page_41"></a>
<p class="indent">Mancuso turned his collar up against the rising breeze. It would be night
            soon, and it was going to rain. He knew they would never solve this murder. He knew that
            if they really tried, they’d be lucky to come out of this alive.</p>
<p class="indent">He looked up at the perfect obelisk of the Washington Monument. He said,
            “If government worked the way it looked, this would be a great place to
            live.” Then he shuffled his feet. Then he walked on.</p>
<p class="indentt"><span class="bold"><span class="font1">6:40 P.M.</span></span> It had
            already begun to rain in Baltimore. The dripping soot blurred the outside of the dirty
            motel window. It was a different rain they had in North America, different from the rain
            in the tropics. A hard rain, a cruel rain, a numbing, beating, freezing rain that dulled
            the senses and chilled the blood.</p>
<p class="indent">Rolf Petersen lay naked on the damp, tangled sheets. He was forty-two,
            blond, and his muscles rippled his fair skin. At his fingertips lay a loaded .44 Smith
            &amp; Wesson revolver, its safety off. He was thinking about the rain in the jungle
            north of Managua, remembering the soft tattoo on the roof, the way the warm mist brought
            the earth smell up through the bare board floor. He remembered how the smell and the
            damp mixed with the lust odor of his lover, how she writhed and bent in the night, and
            arched her back and raised him from the cot. He thought, and he grew hard.</p>
<p class="indent">After they fought and killed, they fucked. Savagely. It was as if the
            orgasm affirmed their survival. They walked on the bloody faces of their fallen enemies,
            then rolled together, seething and panting until they came. Then they rubbed his semen
            on their bodies, as though reanointing themselves with life.</p>
<p class="indent">Now, he lay in a motel room south of Baltimore, remembering the jungle
            two-thousand miles away. Only one person in the world knew where to find him. He touched the
            cold handle of the revolver. God help anyone else who tried.</p>
<a id="page_42"></a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 08_Chapter02.vue?3db6e1ef